import React from 'react';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.primary};
`;

const MixingBoardContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  height: 80px;
  margin-bottom: ${props => props.theme.spacing.lg};
`;

const Slider = styled.div`
  width: 12px;
  height: 60px;
  background: ${props => props.theme.colors.surfaceVariant};
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${props => props.$height}%;
    background: ${props => props.theme.colors.primary};
    border-radius: 6px;
    animation: slideUp 1.5s ease-in-out infinite;
    animation-delay: ${props => props.$delay}s;
  }

  @keyframes slideUp {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-20px); }
  }
`;

const SliderKnob = styled.div`
  position: absolute;
  top: ${props => props.$top}%;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 8px;
  background: ${props => props.theme.colors.surface};
  border: 2px solid ${props => props.theme.colors.primary};
  border-radius: 4px;
  animation: slideUp 1.5s ease-in-out infinite;
  animation-delay: ${props => props.$delay}s;

  @keyframes slideUp {
    0%, 100% { transform: translateX(-50%) translateY(0); }
    50% { transform: translateX(-50%) translateY(-20px); }
  }
`;

const LoadingText = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  color: ${props => props.theme.colors.text.primary};
  margin-bottom: ${props => props.theme.spacing.sm};
  animation: fadeIn 0.8s ease-in-out;
`;

const LoadingSubtext = styled.div`
  font-size: 0.9rem;
  color: ${props => props.theme.colors.text.secondary};
  animation: fadeIn 0.8s ease-in-out 0.3s both;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const LoadingSpinner = ({ text = "Loading...", subtext = "Tweaking Levels!" }) => {
  return (
    <LoadingContainer>
      <MixingBoardContainer>
        <Slider $height={70} $delay={0}>
          <SliderKnob $top={30} $delay={0} />
        </Slider>
        <Slider $height={50} $delay={0.2}>
          <SliderKnob $top={50} $delay={0.2} />
        </Slider>
        <Slider $height={80} $delay={0.4}>
          <SliderKnob $top={20} $delay={0.4} />
        </Slider>
        <Slider $height={60} $delay={0.6}>
          <SliderKnob $top={40} $delay={0.6} />
        </Slider>
        <Slider $height={40} $delay={0.8}>
          <SliderKnob $top={60} $delay={0.8} />
        </Slider>
        <Slider $height={90} $delay={1.0}>
          <SliderKnob $top={10} $delay={1.0} />
        </Slider>
        <Slider $height={55} $delay={1.2}>
          <SliderKnob $top={45} $delay={1.2} />
        </Slider>
      </MixingBoardContainer>
      <LoadingText>{text}</LoadingText>
      <LoadingSubtext>{subtext}</LoadingSubtext>
    </LoadingContainer>
  );
};

export default LoadingSpinner; 